import React, { useEffect, useRef, useState, useCallback } from 'react';
import './NFT.css';
import { useDaily, useLocalSessionId } from '@daily-co/daily-react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { pageAtom, myNftAtom, myNftBackAtom, isAuthAtom, nftDetailAtom } from '../../State';
import 'react-loading-skeleton/dist/skeleton.css';
import { storage } from '../Util/Firebase';
import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { getImagePath } from '../Util/utils';
import DataModel from '../Util/DataModel';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export default function NFTMyCustomItem({ baseName, selectItem }) {
  const [isAuthState, setAuthState] = useRecoilState(isAuthAtom);
  const [selectedState, setSelectedState] = useState(false);
  const [loadingState, setLoadingState] = useState(false);

  //初期化
  useEffect(() => {}, []);

  // const selectItem = async () => {
  //   selectItem();
  // };

  //画像のローディング完了トリガー
  const loadCompleted = async () => {
    setLoadingState(true);
  };

  return (
    <>
      <div className="myAvatarListItem" onClick={selectItem}>
        {selectedState && (
          <div className="myAvatarCheck">
            <img src={getImagePath() + '/styles/check.png'} />
          </div>
        )}
        <img
          src={getImagePath() + '/styles/' + baseName + '.png'}
          onLoad={loadCompleted}
          style={{
            display: !loadingState ? 'none' : 'inline-block',
          }}
        />

        {loadingState == false && (
          <Skeleton baseColor={'#ccc'} highlightColor={'#fff'} height={'150px'} width={'100%'} />
        )}
      </div>
    </>
  );
}
